import { useEffect, useState } from "react";

import { format, formatISO } from "date-fns";

import useData from "../../hooks/useData";

import {
  Box,
  FormControl,
  OutlinedInput,
  InputLabel,
  FormHelperText,
  Typography,
} from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const DateField = ({
  id,
  label,
  value,
  onChange,
  fullwidth,
  disabled,
  multiline,
  message,
  error,
  required,
}) => {
  const { getMessage, getLabel } = useLocalization();
  const [focus, setFocus] = useState(false);
  const { toDate } = useData();

  const getValue = () => {
    if (!value) return "";

    let dateValue = value;

    if (typeof value !== "string") {
      dateValue = format(value, "yyyy-MM-dd");
    }

    return dateValue;
  };

  const updateValue = (e) => {
    const date = toDate(e.target.value);
    onChange(date);
  };

  return (
    <Box>
      <Box sx={{ paddingLeft: "6px", paddingRight: "6px" }}>
        <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
          {getLabel(label)}
        </Typography>
      </Box>
      <FormControl
        id={id}
        fullWidth={fullwidth}
        size="small"
      >
        <OutlinedInput
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          id={id}
          value={getValue()}
          error={error || false}
          onChange={updateValue}
          type={value || focus ? "date" : "text"}
          multiline={multiline}
          required={required}
          disabled={disabled}
          size="small"
          sx={{ fontSize: "12px" }}
        />

        <FormHelperText error={error || false}>
          {getMessage(message) || ""}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default DateField;
